import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import MainLayout from '@/components/MainLayout.vue'
import SignIn from '@/views/SignIn.vue'
import SignUp from '@/views/SignUp.vue'
import AccountOrganizations from '../views/AccountOrganizations.vue'
import AccountSettings from '../views/AccountSettings.vue'
import OrganizationBilling from '@/views/OrganizationBilling.vue'
import OrganizationUsers from '@/views/OrganizationUsers.vue'
import OrganizationTeams from '@/views/OrganizationTeams.vue'
import OrganizationAnalytics from '@/views/OrganizationAnalytics.vue'
import OrganizationSettings from '@/views/OrganizationSettings.vue'
import OrganizationTeamManager from '../views/OrganizationTeamManager.vue'
import OAuthAuthorize from '@/views/OAuthAuthorize.vue'

const router = createRouter({
  // DO NOT Change the history line: https://docs.astro.build/en/guides/environment-variables/
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/oauth2/auth',
      name: 'OAuthAuthorize',
      component: OAuthAuthorize
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/app/:id',
      component: MainLayout,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        try {
          const configStore = useConfigStore()
          const authStore = useAuthStore()
          const configurations = await configStore.fetchConfigurations()
          const orgId = to.params.id
          const targetUrl = `${configurations.appBaseURL}/o/${orgId}#t=${authStore.token}`
          window.location.href = targetUrl
        } catch (error) {
          console.error("Redirect failed:", error)
          next(false)
        }
      }
    },
    {
      path: '/',
      component: MainLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/organizations' },
        { path: 'settings', name: 'Account settings', component: AccountSettings },
        { path: 'organizations', name: 'Organizations', component: AccountOrganizations },
        { path: 'organizations/:id/settings', name: 'Organization settings', component: OrganizationSettings },
        { path: 'organizations/:id/teams', name: 'Teams', component: OrganizationTeams },
        { path: 'organizations/:id/teams/:teamId', name: 'Team manager', component: OrganizationTeamManager },
        { path: 'organizations/:id/users', name: 'Users', component: OrganizationUsers },
        { path: 'organizations/:id/analytics', name: 'Analytics', component: OrganizationAnalytics },
        { path: 'organizations/:id/billing', name: 'Billing', component: OrganizationBilling },
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // Handle OAuth callback: extract token from URL hash BEFORE any auth check.
  // This must happen here (not in App.vue onMounted) to avoid the race where
  // the guard runs before onMounted and redirects to /signin prematurely.
  if (!authStore.isAuthenticated) {
    await authStore.handleLoginCallback()
  }

  if (to.meta.requiresAuth) {
    if (!authStore.isAuthenticated) {
      await authStore.fetchUser()
    }
    if (!authStore.isAuthenticated) {
      next('/signin')
    } else {
      next()
    }
  } else {
    if (authStore.isAuthenticated && (to.name === 'SignIn' || to.name === 'SignUp') && to.query.signout !== 'true') {
      next('/')
    } else {
      next()
    }
  }
})

export default router